import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function BookingSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { slug } = useParams();
  const { apt, biz, waUrl } = location.state || {};

  useEffect(() => {
    if (!apt) navigate(`/agenda/${slug}`, { replace: true });
  }, [apt, navigate, slug]);

  if (!apt) return null;

  return (
    <div className="min-h-screen bg-void text-neutral-100 grain flex flex-col">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center animate-fade-up">
          <div className="w-16 h-16 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-8 h-8 text-gold" strokeWidth={1.5} />
          </div>
          <p className="overline mb-2">¡Cita reservada!</p>
          <h1 className="font-display text-4xl mb-4" data-testid="success-title">Un paso más</h1>
          <p className="text-neutral-400 mb-6 leading-relaxed">
            Envía tu comprobante de pago por WhatsApp para confirmar tu cita de{" "}
            <span className="text-gold">{apt.service_name}</span> el {apt.date} a las {apt.time}. Anticipo: <span className="text-gold">${apt.deposit}</span>.
          </p>
          {waUrl && (
            <a href={waUrl} target="_blank" rel="noreferrer" data-testid="success-whatsapp-btn">
              <Button className="w-full bg-gold text-void hover:bg-gold/90 rounded-full font-bold h-14 text-base">
                <MessageCircle className="w-4 h-4 mr-2" /> Abrir WhatsApp
              </Button>
            </a>
          )}
          <Button
            variant="ghost"
            className="mt-3 text-neutral-400"
            onClick={() => navigate(`/agenda/${slug}`)}
            data-testid="new-booking-btn"
          >
            Reservar otra cita
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
